import { UPDATE_SAPDATA, GET_SAPDATA_LIST } from '../constant';
import { getSapDatasApi, updateSapDataApi } from '../../api';

export const getSapDatas = (data) => ({
	type: GET_SAPDATA_LIST,
	data,
});

export const updateSapData = (data) => ({
	type: UPDATE_SAPDATA,
	data,
});

export const getSapDatasAsync = (params) => {
	const pageSize = 15;
	params = { ...params, pageSize };
	return (dispatch) => {
		return getSapDatasApi(params)
			.then((data) => {
				if (data.errorCode.trim().length === 0) {
					const totalCount = (data.value as any)?.total ?? 0;
					const totalpage =
						parseInt(parseInt(totalCount) / pageSize + '') +
						(totalCount % pageSize > 0 ? 1 : 0);
					dispatch(
						getSapDatas({ data: (data.value as any)?.data ?? [], total: totalpage })
					);
				} else {
					console.error(`${data.errorCode}:: ${data.errorMessage}`);
				}
			})
			.catch((error) => {
				throw error;
			});
	};
};

export const updateSapDataAsync = (data) => async (dispatch) => {
	try {
		const response = await updateSapDataApi(data);
		if (response.errorCode.trim().length === 0) {
			console.log(':::::::::::updateSapDataAsync', response.value);
			dispatch(updateSapData(response.value));

			return Promise.resolve(response.value);
		} else {
			return Promise.reject(response.errorMessage);
		}
	} catch (error) {
		return Promise.reject(error);
	}
};
